<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="form" (ngSubmit)="save()" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid">

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.user_id.nullable}">{{ fields.user_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [filter]="true" [options]="usersAutoComplete" formControlName="user_id" [style]="{'width':'100%'}" ></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.user_id"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{ ('common.add' | translate) }} {{ 'roleMS.user' |translate }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationUsersForm.component.html